module.exports = __webpack_public_path__ + "static/media/error-icon.5a1deb4d.svg";